export default __webpack_public_path__ + "static/media/status_meeting.5ecebf5b.svg";